import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgOftenOilyGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M30.337 28.071c-.422-.57-.835-1.089-1.236-1.577 3.338-2.647 3.853-6.921 1.236-10.413-.793-1.058-1.566-1.984-2.236-2.798-1.69-2.016-2.905-3.492-2.946-5.201V8h-1.288c0 1.842-1.288 3.38-3.246 5.7-.597.712-1.256 1.496-1.936 2.361-2.648 3.38-2.123 7.766 1.256 10.443-.401.488-.824.997-1.256 1.547-2.659 3.38-2.123 7.776 1.267 10.453 1.226.967 2.843 1.496 4.554 1.496 1.7 0 3.307-.519 4.533-1.476 3.4-2.626 3.925-6.931 1.298-10.453ZM19.704 16.845c.67-.855 1.32-1.618 1.906-2.33 1.247-1.487 2.288-2.718 2.906-3.98.587 1.15 1.525 2.27 2.586 3.552.67.804 1.422 1.71 2.194 2.738 2.215 2.961 1.803 6.442-1.01 8.671a3.682 3.682 0 0 1-.185-.234c-1.68-2.015-2.905-3.49-2.946-5.2v-.082h-1.288c0 1.791-1.226 3.297-3.101 5.526-2.864-2.239-3.297-5.801-1.061-8.661Zm7.47 9.323a6.418 6.418 0 0 1-5.285.02c1.123-1.333 2.06-2.483 2.637-3.643.587 1.15 1.525 2.27 2.586 3.552.01.02.041.05.062.071Zm1.071 11.369c-.999.774-2.318 1.201-3.73 1.201-1.42 0-2.76-.427-3.75-1.221-2.864-2.26-3.296-5.832-1.05-8.682.463-.59.906-1.12 1.329-1.639 1.03.53 2.225.814 3.472.814a7.748 7.748 0 0 0 3.503-.824 55.51 55.51 0 0 1 1.288 1.639c2.225 2.982 1.792 6.483-1.062 8.712Z",
    fill: "currentColor"
  }));
}

export { SvgOftenOilyGlyph as default };
